export default {
    getAllDeliveries(state) {
        if (state.allDeliveries) {
            return state.allDeliveries.filter(delivery => delivery.self_collection === false).sort((a, b) => {
                return a.beneficiary_id - b.beneficiary_id
            });
        }
    },
    getSelfCollections(state) {
        if (state.allDeliveries) {
            return state.allDeliveries.filter(delivery => delivery.self_collection === true).sort((a, b) => {
                return a.beneficiary_id - b.beneficiary_id
            });
        }
    },
    getDeliveriesForTeam: (state) => (team) => {
        if (state.allDeliveries && team) {
            return state.allDeliveries.filter(delivery => delivery.delivery_team === team).sort((a, b) => {
                return a.delivery_sort - b.delivery_sort
            });
        }
    },
    getDeliveries(state) {
        if (state.deliveries) {
            return state.deliveries.sort((a, b) => {
                return a.delivery_sort - b.delivery_sort;
            });
        }
    },
    getPendingSelfCollection(state) {
        if (state.pendingSelfCollection) {
            return state.pendingSelfCollection.sort((a, b) => {
                return a.beneficiary_id - b.beneficiary_id;
            });
        }
    },
    getNotDeliveredDeliveries(state) {
        if (state.notDeliveredDeliveries) {
            return state.notDeliveredDeliveries.sort((a, b) => {
                return a.beneficiary_id - b.beneficiary_id;
            });
        }
    },
    getDeliveryBagsCount(state) {
        return state.deliveryBagsCount;
    },
    getDelivery(state) {
        return state.delivery;
    },
    getSearchHistoricalDeliveries(state) {
        return state.searchHistoricalDeliveries;
    },
    getTotalDeliveriesToGenerate(state) {
        return state.totalDeliveriesToGenerate;
    },
    getDeliveriesGeneratedCount(state) {
        return state.deliveriesGeneratedCount;
    },
    getDeliveryStats(state) {
        return state.deliveryStats;
    },
    getDeliveryStatsLoading(state) {
        return state.deliveryStatsLoading;
    },
    getStatsRefreshCooldownUntil(state) {
        return state.statsRefreshCooldownUntil;
    }
}